// Palette partagee : palette de couleurs des formats RichText (shared/colors.js)
// et valeurs par defaut de certains blocs (galerie).
//
// Ces valeurs sont volontairement ecrites en dur plutot que lues depuis
// colors.module.scss. Le generateur de configuration PHP de
// js-block-engine-devtools evalue chaque block.js dans un bac a sable qui ne
// resout que .js/.jsx/.ts/.tsx (BlockDev.resolveModulePath) : un import .scss y
// devient un Proxy. Un `withDefault(style.orange)` produit alors une valeur non
// serialisable, la cle `default` disparait du fichier .block.config.php genere,
// et le bloc perd sa valeur par defaut cote serveur. C'est ce qui faisait
// passer le point du titre de la galerie de l'orange au blanc.
//
// Source de verite des teintes : les variables $blue, $blueGrey, $orange,
// $darkWhite et $white de src/common.scss. Toute modification la-bas doit etre
// repercutee ici.
const blue = "#0F203D";
const blueGrey = "#1C3756";
const orange = "#ED6C21";
const darkWhite = "#EAF1F4";
const white = "#fff";

const colors = [
    { name: 'Blue', color: blue },
    { name: 'BlueGrey', color: blueGrey },
    { name: 'Orange', color: orange },
    { name: 'DarkWhite', color: darkWhite },
    { name: 'White', color: white },
];

const colorPalette2 = [
    { name: 'Orange', color: orange },
    { name: 'White', color: white },
];

export { colors };
export { colorPalette2 };
